import api from './index';

const authAPI = {
  // Register a new user
  register: (userData) => {
    return api.post('/register_plain', userData);
  },
  
  // Login with email and password
  login: (credentials) => {
    return api.post('/login_plain', credentials);
  },
  
  // Request WhatsApp verification code
  requestWhatsAppCode: (phoneNumber = null) => {
    const data = phoneNumber ? { phone_number: phoneNumber } : {};
    return api.post('/request_whatsapp_code', data);
  },
  
  // Verify WhatsApp code
  verifyWhatsAppCode: (code, phoneNumber = null) => {
    const data = {
      verification_code: code
    };
    
    if (phoneNumber) {
      data.phone_number = phoneNumber;
    }
    
    return api.post('/verify_whatsapp_code', data);
  },
  
  // Request password reset
  requestPasswordReset: (email) => {
    return api.post('/request_reset_password', { email });
  },
  
  // Verify password reset code
  verifyPasswordResetCode: (email, code) => {
    return api.post('/verify_reset_password_code', {
      email,
      verification_code: code
    });
  },
  
  // Reset password
  resetPassword: (newPassword, token) => {
    return api.post('/reset_password', 
      { new_password: newPassword },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
  }
};

export default authAPI;
